module.exports = {"350581001":"湖滨街道","350581002":"凤里街道","350581100":"灵秀镇","350581101":"宝盖镇","350581102":"蚶江镇","350581103":"祥芝镇","350581104":"鸿山镇","350581105":"锦尚镇","350581106":"永宁镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/350581.json
// module id = 1206
// module chunks = 0